import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { ArrowRight } from "react-bootstrap-icons";
import { brandName } from "../../../../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
  textGreyColor,
  textLightColor,
} from "../../../../Constants/Colors";

import ErrorAlert from "../../../../Components/ErrorAlert";
import GetInTouch from "../../../../Components/GetInTouch";
import { useGetServicesQuery } from "../../../../redux/api/ServicesApi/servicesApi";
import { Link, useNavigate } from "react-router-dom";

const ServicesSection = () => {
  const navigate = useNavigate();
  const [hoverIndex, setHoverIndex] = useState(null);

  // Use the services API hook
  const { data, error, isLoading } = useGetServicesQuery({
    limit: 4,
    status: true,
    sortBy: "display_order",
    order: "asc",
  });

  // Handle loading state
  if (isLoading) {
    return (
      <section
        style={{
          backgroundColor: primaryColor,
          color: textLightColor,
          padding: "60px 0",
        }}
      >
        <Container>
          <div className="text-center">
            <div className="spinner-border text-light" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </section>
    );
  }

  // Handle error state
  if (error) {
    return (
      <>
        <ErrorAlert
          message="Unable to fetch services. Please try again later."
          iconSize={30}
        />
      </>
    );
  }

  const services = data?.services;

  console.log("services", services.defaultText);

  return (
    <section
      style={{
        backgroundColor: primaryColor,
        color: textLightColor,
        padding: "60px 0",
      }}
    >
      <Container>
        <Row className="mb-4 mx-auto justify-content-center">
          <Col md={8} lg={8}>
            <p
              className="text-uppercase text-white mb-1"
              style={{ fontSize: "14px" }}
            >
              Our Services
            </p>
            <h2 className="fw-bold text-white">
              Boost <span style={{ color: secondaryColor }}>Your Brand</span>
              <br />
              With Our Expertise
            </h2>
            <p
              style={{
                fontSize: "14px",
                color: textLightColor,
                textAlign: "justify",
              }}
            >
              At {brandName}, we create digital experiences that enhance your
              brand and inspire your audience. Our dedicated team delivers
              innovative solutions, driven by your vision.
            </p>
          </Col>
          <Col md={4} lg={3} className="text-md-center text-end">
            <Button
              className="rounded-pill "
              onClick={() => navigate("/services")}
              style={{
                backgroundColor: secondaryColor,
                color: textDarkColor,
                fontWeight: "600",
                border: "none",
              }}
            >
              View All Services →
            </Button>
          </Col>
        </Row>

        {services.map((service, index) => (
          <Card
            key={service.id}
            className={`mb-4 px-1 py-1 py-lg-4 border-0 shadow m-auto card-hover-animated ${
              hoverIndex === index ? "hovered" : ""
            }`}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
            style={{
              borderRadius: "16px",
              height: "210px",
              "--hover-color": secondaryColor,
            }}
          >
            <Card.Body className="">
              <Row className="d-flex justify-content-center align-items-center h-100">
                <Col
                  xs={1}
                  md={2}
                  lg={hoverIndex === index ? 2 : 2}
                  className="align-items-center justify-content-start justify-content-md-center d-none d-md-flex"
                >
                  {hoverIndex === index ? (
                    <Image
                      src={service.headerImage}
                      alt={service.service_title}
                      fluid
                      className="d-none d-md-flex"
                    />
                  ) : (
                    <h3
                      style={{ color: primaryColor, fontWeight: "bold" }}
                      className=""
                    >
                      {index + 1}.
                    </h3>
                  )}
                </Col>
                <Col
                  xs={hoverIndex === index ? 12 : 12}
                  md={hoverIndex === index ? 8 : 8}
                  lg={hoverIndex === index ? 6 : 6}
                  className="d-flex flex-column align-items-start justify-content-center"
                  style={{
                    transform:
                      hoverIndex === index
                        ? "translateX(20px)"
                        : "translateX(0)",
                    transition: "transform 0.5s ease-in-out",
                  }}
                >
                  <h5
                    style={{
                      color:
                        hoverIndex === index ? textGreyColor : primaryColor,
                    }}
                  >
                    {service.service_title}
                  </h5>
                  <p
                    style={{
                      fontSize: "14px",
                      color:
                        hoverIndex === index ? textGreyColor : textDarkColor,
                    }}
                  >
                    {hoverIndex === index
                      ? service.hoverText
                      : service.defaultText}
                  </p>
                  <Link
                    to={`/services/${service.service_slug}`}
                    className="mb-0 fw-semibold text-decoration-none"
                    style={{
                      color:
                        hoverIndex === index ? textGreyColor : primaryColor,
                    }}
                  >
                    Know More →
                  </Link>
                </Col>
                <Col
                  xs={1}
                  md={2}
                  className="text-end d-none d-md-flex align-items-center justify-content-end"
                >
                  <Link
                    to={`/services/${service.service_slug}`}
                    className="mb-0 fw-semibold text-decoration-none"
                    style={{
                      color:
                        hoverIndex === index ? textGreyColor : primaryColor,
                    }}
                  >
                    <ArrowRight
                      size={50}
                      style={{
                        transform:
                          hoverIndex === index
                            ? "rotate(-30deg) translateZ(0)"
                            : "rotate(0deg) translateZ(0)",
                        transition: "transform 0.5s ease-in-out",
                        color:
                          hoverIndex === index ? textGreyColor : primaryColor,
                        willChange: "transform",
                      }}
                    />
                  </Link>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        ))}
        <Col xs={12} className="d-flex mb-3">
          <Button
            className="rounded-pill me-1 ms-auto"
            onClick={() => navigate("/services")}
            style={{
              backgroundColor: secondaryColor,
              color: textDarkColor,
              fontWeight: "600",
              border: "none",
            }}
          >
            View All Services →
          </Button>
        </Col>

        <GetInTouch />
      </Container>
    </section>
  );
};

export default ServicesSection;
